import { Box, Colors, FlexBox, H5, MeasureBoldIcon, Tag } from '@helloself/hello-self-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BaseTileProps } from '../../../model/types';
import { EmptyTilePlaceholder } from '../../EmptyTilePlaceholder';
import { TagContent } from '../../TagContent';
import Tile from '../../Tile';

export type TypesOfTherapyTileProps = BaseTileProps & {
    treatmentApproaches?: string[];
};

export function TypesOfTherapyTile({ treatmentApproaches, isLoading, isOwnProfile }: TypesOfTherapyTileProps) {
    if (isLoading) {
        return (
            <Tile>
                <FlexBox flexDirection="column" gap="24px" data-testid="TypesOfTherapyTile">
                    <H5 margin="0">Treatment approaches I can offer</H5>
                    <FlexBox flexDirection="row" gap="8px">
                        <Box height="24px" width="24px">
                            <MeasureBoldIcon width="24px" height="24px" />
                        </Box>
                        <FlexBox gap="8px" flexWrap="wrap">
                            <Skeleton width="140px" height="38px" />
                            <Skeleton width="120px" height="38px" />
                            <Skeleton width="100px" height="38px" />
                        </FlexBox>
                    </FlexBox>
                </FlexBox>
            </Tile>
        );
    }

    if (!treatmentApproaches || treatmentApproaches.length === 0) {
        return (
            <Tile>
                <FlexBox flexDirection="column" gap="12px" data-testid="TypesOfTherapyTile">
                    <H5 margin="0">Treatment approaches I can offer</H5>
                    <EmptyTilePlaceholder isOwnProfile={isOwnProfile} />
                </FlexBox>
            </Tile>
        );
    }

    return (
        <Tile>
            <FlexBox flexDirection="column" gap="24px" data-testid="TypesOfTherapyTile">
                <H5 margin="0">Treatment approaches I can offer</H5>
                <FlexBox flexDirection="row" gap="8px">
                    <Box height="24px" width="24px">
                        <MeasureBoldIcon width="24px" height="24px" />
                    </Box>
                    <FlexBox gap="8px" flexWrap="wrap">
                        {treatmentApproaches?.map((tag, index) => (
                            <Box padding="3px 0" key={index} borderRadius={8} border={`1px solid #e8e8e8`}>
                                <Tag color={Colors.black} backgroundColor={Colors.white}>
                                    <TagContent>{tag}</TagContent>
                                </Tag>
                            </Box>
                        ))}
                    </FlexBox>
                </FlexBox>
            </FlexBox>
        </Tile>
    );
}
